import { FormBuilder } from 'reservations/form/helpers/FormBuilder';

export function cleanCreateBookingFormData(formData: Record<string, any>) {
  const form = new FormBuilder()
    .addName(formData['name'])
    .addEmail(formData['email'])
    .addPhoneNumber(formData['phone'], formData['phoneCode'])
    .addDatetime(formData['date'], formData['availability'])
    .addPartySize(formData['partySize'])
    .addNote(formData['note'])
    .addSpecialOccasion(formData['specialOccasion'])
    .addMarketingOptIn(
      formData['optInMarketingEmail'],
      formData['optInMarketingSms']
    )
    .build();
  return form;
}

export function cleanUpdateBookingFormData(formData: Record<string, any>) {
  const form = new FormBuilder()
    .addName(formData['name'])
    .addEmail(formData['email'])
    .addPhoneNumber(formData['phone'], formData['phoneCode'])
    .addDatetime(formData['date'], formData['availability'])
    .addPartySize(formData['partySize'])
    .addNote(formData['note'])
    .addSpecialOccasion(formData['specialOccasion'])
    .build();
  return form;
}
